import _ from "lodash";
import React from "react";
import PropTypes from "prop-types";

import { Modal, Button } from "@toddle-edu/ds-web";

import classes from "./DiscardLearningGoalsModal.scss";

const DiscardLearningGoalsModal = props => {
  const {
    headerTitle,
    message,
    buttonLabel1,
    buttonLabel2,
    onClickButton1,
    onClickButton2,
    onCloseDiscardModal,
    testId,
  } = props;

  return (
    <Modal width="440px" height="max-content" onClose={onCloseDiscardModal}>
      <Modal.Header
        testId={`${testId}-discardModal`}
        title={headerTitle}
        isCloseable={true}
      />
      <Modal.Body>
        <div className={`text-body-1 ${classes.message}`}>{message}</div>
      </Modal.Body>
      <Modal.Footer>
        <div className={classes.footerContainer}>
          <Button
            dsVersion="2.0"
            variant="neutral"
            type="outlined"
            size="medium"
            onClick={onClickButton1}
            testId={`${testId}-discardModal-${_.camelCase(buttonLabel1)}`}
          >
            {buttonLabel1}
          </Button>
          <Button
            dsVersion="2.0"
            testId={`${testId}-discardModal-${_.camelCase(buttonLabel2)}`}
            size="medium"
            onClick={onClickButton2}
          >
            {buttonLabel2}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

DiscardLearningGoalsModal.propTypes = {
  headerTitle: PropTypes.string,
  message: PropTypes.string,
  buttonLabel1: PropTypes.string,
  buttonLabel2: PropTypes.string,
  onClickButton1: PropTypes.func,
  onClickButton2: PropTypes.func,
  onCloseDiscardModal: PropTypes.func,
};

DiscardLearningGoalsModal.defaultProps = {
  testId: "IBComponents",
};

export default DiscardLearningGoalsModal;
